export function Time(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 5C12.6628 5 13.2 5.53726 13.2 6.2V10.6H16.6C17.2628 10.6 17.8 11.1373 17.8 11.8C17.8 12.4627 17.2628 13 16.6 13L12 13C11.3373 13 10.8 12.4627 10.8 11.8V6.2C10.8 5.53726 11.3373 5 12 5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.800049 12C0.800049 5.81441 5.81446 0.800003 12 0.800003C18.1856 0.800003 23.2 5.81441 23.2 12C23.2 18.1856 18.1856 23.2 12 23.2C5.81446 23.2 0.800049 18.1856 0.800049 12ZM20.8 12C20.8 7.1399 16.8602 3.2 12 3.2C7.13994 3.2 3.20005 7.1399 3.20005 12C3.20005 16.8601 7.13994 20.8 12 20.8C16.8602 20.8 20.8 16.8601 20.8 12Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
